import { $env } from "@/utils/utils";

export default function ({ next }) {
  if ($env.prod) {
    return next({ name: "notFound" });
  }

  return next();
}
